module.exports = __webpack_public_path__ + "img/wx-share-v3.75f27330.png";